export const environment = {
  appName: 'SMP',
  appCode: 'EBT',
  editType: 'modal',
  production: true,
  backendUrl: 'https://smp-backend.appfiz-corp.com',
  useProductUnit: false,
  useProductStock: false,
  useGeneralBoxDelivery: false,
};
